/**
 * why: storage reads AND writes THROW (SecurityError when storage is blocked —
 * private mode, third-party-cookie blocking, sandboxed iframe; QuotaExceededError
 * when full) rather than returning null or silently doing nothing. The call sites
 * are redux reducers, route loaders, `beforeLoad` / `onEnter` hooks and render
 * bodies, so an uncaught throw unmounts the React tree — a white screen instead of
 * a merely unpersisted token. Persistence is best-effort; crashing is not.
 *
 * Single home for the guard so the policy cannot drift per file; a second
 * hand-rolled copy is how the unguarded sites this module replaces went unnoticed.
 */
export function safeStorageGet(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function safeStorageSet(
  storage: Storage,
  key: string,
  value: string,
): void {
  try {
    storage.setItem(key, value);
  } catch {
    // ignore — best-effort persistence
  }
}

export function safeStorageRemove(storage: Storage, key: string): void {
  try {
    storage.removeItem(key);
  } catch {
    // ignore — best-effort persistence
  }
}
